module.exports = __webpack_public_path__ + "static/media/Milex-Dish-Pessary-Instructions-for-Use.6d9d51d2.jpg";